import { createContext, useContext } from 'react';

export const KeycloakContext = createContext();
export const useKeycloakContext = () => useContext(KeycloakContext);
